import PropTypes from "prop-types";

import useAssignmentReducerContext from "@/view/utils/useAssignmentReducerContext";
import SecondaryActionsToolbar from "@/view/SecondaryActionsToolbar";
import ContentVeil from "@/components/ContentVeil";
import { ChecksForUnderstandingSubmissionsContextProvider } from "@/assignments/useChecksForUnderstandingSubmissionsContext/useChecksForUnderstandingSubmissionsContext";
import { ARTICLE_BODY_ORIGIN } from "../../../grading/constants";
import ArticleBody from "../ArticleBody";
import { rootCss } from "../ContentDisplay.style";
import ContentDisplayDetails from "../ContentDisplayDetails";
import ContentDisplayHeaderMedia from "../ContentDisplayHeaderMedia";
import TeacherTools from "../TeacherTools";

const propTypes = {
  bannerMode: PropTypes.object.isRequired,
  content: PropTypes.object,
  contentMetadata: PropTypes.array,
  currentLevel: PropTypes.object,
  isVocabularySupportEnabled: PropTypes.bool,
  keyTermDataContentId: PropTypes.string,
  legacyArticleId: PropTypes.number,
  matchedAssignments: PropTypes.array,
  rawText: PropTypes.object,
  readAloudButtonRef: PropTypes.object,
  shouldShowMobileActions: PropTypes.bool,
  toggleVocabularySupport: PropTypes.func,
  user: PropTypes.object,
  userProperties: PropTypes.object,
  contentDisplayRef: PropTypes.oneOfType([PropTypes.element, PropTypes.object]),
};

const unauthPropTypes = {
  content: PropTypes.object,
  currentLevel: PropTypes.object,
};

const ArticleDisplay = ({
  content,
  currentLevel,
  contentMetadata,
  isVocabularySupportEnabled,
  keyTermDataContentId,
  matchedAssignments,
  rawText,
  readAloudButtonRef,
  shouldShowMobileActions,
  toggleVocabularySupport,
  userProperties,
  bannerMode,
  legacyArticleId,
  contentDisplayRef,
  user,
}) => {
  const { isTeacher, isStudent } = userProperties;
  const { updatedAssignment: currentAssignment } =
    useAssignmentReducerContext();

  return (
    <div css={rootCss} ref={contentDisplayRef}>
      <ContentDisplayHeaderMedia
        contentData={content.data}
        currentLevel={currentLevel}
      />
      <ContentDisplayDetails
        contentData={content.data}
        contentMetadata={contentMetadata}
        isTeacher={isTeacher}
        isStudent={isStudent}
        currentLevel={currentLevel}
        bannerMode={bannerMode}
      />
      <SecondaryActionsToolbar
        bannerMode={bannerMode}
        content={content}
        currentLevel={currentLevel}
        matchedAssignments={matchedAssignments}
        readAloudButtonRef={readAloudButtonRef}
        shouldShowMobileActions={shouldShowMobileActions}
        user={user}
        userProperties={userProperties}
      />
      <TeacherTools
        content={content}
        currentLevel={currentLevel}
        contentMetadata={contentMetadata}
      />
      <ChecksForUnderstandingSubmissionsContextProvider
        contentId={content.id}
        currentAssignment={currentAssignment}
      >
        <ArticleBody
          keyTermDataContentId={keyTermDataContentId}
          language={currentLevel.language}
          legacyArticleId={legacyArticleId}
          levelId={currentLevel?.id}
          isVocabularySupportEnabled={isVocabularySupportEnabled}
          rawText={rawText}
          toggleVocabularySupport={toggleVocabularySupport}
          userProperties={userProperties}
          componentOrigin={ARTICLE_BODY_ORIGIN.VIEW_PAGE}
          content={content}
          contentMetadata={contentMetadata}
          lexile={`${currentLevel?.lexile || ""}`}
        />
      </ChecksForUnderstandingSubmissionsContextProvider>
    </div>
  );
};

const Unauth = ({ content, currentLevel }) => {
  return (
    <div css={rootCss}>
      <ContentDisplayHeaderMedia
        contentData={content.data}
        currentLevel={currentLevel}
      />
      <ContentDisplayDetails.Unauth
        contentData={content.data}
        currentLevel={currentLevel}
      />
      <ContentVeil />
    </div>
  );
};

ArticleDisplay.propTypes = propTypes;
Unauth.propTypes = unauthPropTypes;

ArticleDisplay.Unauth = Unauth;

export default ArticleDisplay;
